import axios from "axios";


export const contribuyenteService = {
  async getContribuyentes(data) {
    try {
      let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/recImpContrib.php", {
        data: {
          bsq: 1,
          ...data
        }
      });

      if (response.data?.mensaje) return response.data?.mensaje;

      let result = response?.data;

      return result;
    }
    catch (error) {
      return "error";
    }
  },
  async getContribuyente(data) {
    try {
      const { recurso, imponible } = data;

      let response = await axios.get(`https://wsrfa.sannicolasciudad.gob.ar/consultas/deudaCC.php?recurso=${recurso}&imponible=${imponible}&concepto=0`);

      return response.data;
    }
    catch (err) {
      return err.message;
    }
  }
};
